import { RootState } from 'src/reducers';
import { selectFlags } from './select-flags';

export const shouldExposeVideoPrivacyChange = (state: RootState) =>
  selectFlags(state)['expose-video-privacy-change'] === undefined
    ? true
    : selectFlags(state)['expose-video-privacy-change'];
